
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import appconst from '@/lib/appconst';
    import mainLandPackageList from '@/store/entities/back-mainlandpackage'
    //class AddShipment {
    //    mainlandShipment: string;
    //}
    @Component
    export default class CreateLogisticsModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        //Shipment: AddShipment = new AddShipment();
        selectMainLandPackage: mainLandPackageList = new mainLandPackageList();
        MainLandPackage: Array<mainLandPackageList> = [];
        packageName: string = "";
        MainLandPackageSelect: Array<mainLandPackageList> = [];
        type: number = 0;
        created() {
            //this.type = this.$store.state.backmainlandorder.cargoCategory;
            //this.mainlandShipment = this.$store.state.backmainlandorder.internationShipment;
            this.get();
        }

        async updatePackage() {
            this.MainLandPackageSelect = [];
            this.get();
            var _this = this;
            this.MainLandPackageSelect = this.MainLandPackage.filter(function (item) { return item.isSend == false && item.cargoCategory == _this.type });
            if (this.packageName != "") {
                var data = this.MainLandPackageSelect.filter(function (item) { return item.isSend == false && item.packageName == _this.packageName });
                if (data.length > 0) {
                    this.selectMainLandPackage.id = data[0].id;
                }
            }
        }
        async get() {

            this.MainLandPackage =await this.$store.dispatch({
                type: 'mainlandpackage/getMainLandPackageList',
                data: {}
            });
  

        }
        async save() {

         
            var id = this.$store.state.backmainlandorder.id;
            await this.$store.dispatch({

                type: 'backmainlandorder/editShipment',
                data: { id: id, mainLandPackageId: this.selectMainLandPackage.id }
            });
            

            (this.$refs.shipmentForm as any).resetFields();
            this.$emit('save-success');
            this.$emit('input', false);
        }



        cancel() {
            (this.$refs.shipmentForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                this.type = this.$store.state.backmainlandorder.cargoCategory;
                this.packageName = this.$store.state.backmainlandorder.packageName;
                if (this.MainLandPackage.length > 0) {
                    var _this = this;
                    this.MainLandPackageSelect = this.MainLandPackage.filter(function (item) { return item.isSend == false && item.cargoCategory == _this.type });
                    if (this.packageName != "") {
                        var data = this.MainLandPackageSelect.filter(function (item) { return item.isSend == false && item.packageName == _this.packageName });
                        if (data.length > 0) {
                            this.selectMainLandPackage.id = data[0].id;
                        }
                    }
                    //  this.selectuser.id = this.user[0].id;
                }
            }
        }
        //shipmentRule = {
        //    mainlandShipment: [
        //        { required: true, message: '本土物流单号快递不能为空', trigger: 'blur' }
        //    ]
        //};

    }
